<template>
	<div>
		<div v-if="!minimal">
			<b-container style="margin: 0; padding: 0; max-width: none">
				<b-row>
					<b-col cols="9">
						<h1>{{dashboard.title}}</h1>
					</b-col>
					<b-col>
						<b-select v-if="names.length > 1" @change="load_name()" v-model="name" :options="names"></b-select>
					</b-col>
				</b-row>
			</b-container>
		</div>

		<b-container v-show="mode == 'small'" style="margin: 0; padding: 0; max-width: none">
			<b-row v-for="(line_blocks, id_line) in dashboard.blocks" :key="line_blocks.uid">
				<b-col style="margin: 0px; padding: 0px;" v-show="block.size !== 0" :cols="effectiveSize(line_blocks, block)" v-for="(block, idx) in line_blocks.blocks" :key="block.uid">
					<div style="background-color: white; margin: 10px; padding: 10px; border: 0px solid black; border-radius: 25px;height:calc(100% - 20px);">
						<div style="float: right;">
						<b-button v-if="!block.no_expand" size="sm" variant="link" @click="setBig(id_line, idx)"><i class="fas fa-expand-alt"></i></b-button>
							<span v-if="block.blocks">
								<span v-for="sub_block in block.blocks" :key="sub_block.uid">
									<i :id="'tooltip' + sub_block.uid" :class="sub_block.icon"></i>
									<b-tooltip placement="left" custom-class="long-tooltip" :target="'tooltip' + sub_block.uid">
										<d_text :tooltip="true" :init_params="sub_block.params" format="small" v-if="sub_block.type == 'text'"></d_text>
										<db :tooltip="true" :init_params="sub_block.params" format="small" v-if="sub_block.type == 'db'"></db>
									</b-tooltip>
								</span>
							</span>
						</div>
						<div style="text-align:center">
							<h3>{{block.name}}</h3>
						</div>
						<d_text format="small" :ref="block.uid" v-if="block.type == 'text'"></d_text>
						<db format="small" :test_jwt="test_jwt" :ref="block.uid" v-if="block.type == 'db'"></db>
						<notifs format="small" :test_jwt="test_jwt" :ref="block.uid" v-if="block.type == 'notifs'"></notifs>
						<dashboard_button @action="refresh" :config="config" :user="user" :test_jwt="test_jwt" format="small" :ref="block.uid" v-if="block.type == 'button'"></dashboard_button>
						<actions format="small" :test_jwt="test_jwt" :ref="block.uid" v-if="block.type == 'actions'"></actions>
						<vue_component format="small" :test_jwt="test_jwt" :test_user="test_user" :ref="block.uid" v-if="block.type == 'vue_component'"></vue_component>
						<d_table format="small" :test_jwt="test_jwt" :ref="block.uid" v-if="block.type == 'table'"></d_table>
						<br />
					</div>
				</b-col>
			</b-row>
		</b-container>
		<div style="background-color: white; margin: 10px; padding: 10px; border: 0px solid black; border-radius: 25px;" v-if="mode == 'big'">
			<div style="float: right;">
				<b-button size="sm" variant="link" @click="setSmall()"><i class="fas fa-compress-alt"></i></b-button>
				<span v-if="block.blocks">
					<span v-for="sub_block in block.blocks" :key="sub_block.uid">
						<i :id="'b-tooltip' + sub_block.uid" :class="sub_block.icon"></i>
						<b-tooltip placement="left" custom-class="long-tooltip" :target="'b-tooltip' + sub_block.uid">
							<d_text :tooltip="true" :init_params="sub_block.params" format="small" v-if="sub_block.type == 'text'"></d_text>
							<db :tooltip="true" :init_params="sub_block.params" format="small" v-if="sub_block.type == 'db'"></db>
						</b-tooltip>
					</span>
				</span>
			</div>
			<div style="text-align:center">
				<h3>{{block.name}}</h3>
			</div>
			<d_text format="big" ref="block" v-if="block.type == 'text'"></d_text>
			<db format="big" :test_jwt="test_jwt" ref="block" v-if="block.type == 'db'"></db>
			<notifs format="big" :test_jwt="test_jwt" ref="block" v-if="block.type == 'notifs'"></notifs>
			<dashboard_button @action="refresh" :config="config" :user="user" :test_jwt="test_jwt" format="big" ref="block" v-if="block.type == 'button'"></dashboard_button>
			<actions format="big" :test_jwt="test_jwt" ref="block" v-if="block.type == 'actions'"></actions>
			<vue_component format="big" :test_jwt="test_jwt" :test_user="test_user" ref="block" v-if="block.type == 'vue_component'"></vue_component>
			<d_table format="big" :test_jwt="test_jwt" ref="block" v-if="block.type == 'table'"></d_table>
		</div>
	</div>
</template>

<script>
	import actions from "../components/dashboard/actions.vue";
	import notifs from "../components/dashboard/notifs.vue";
	import button from "../components/dashboard/button.vue";
	import text from "../components/dashboard/text.vue";
	import db from "../components/dashboard/db.vue";
	import vueComponent from "../components/dashboard/vueComponent.vue";
	import dashboardTable from "../components/dashboard/table.vue";
	import database from "../services/database.js";
	import library from "../services/library.js";
    import client from "../services/client.js";
	import users from "../services/users.js";
	import store from "../store"
	
	import alasql from "alasql";

	var clone = require("clone");

	export default {
		name: "dashboard",
		components: {
			db,
			d_text: text,
			notifs: notifs,
			actions,
			dashboard_button: button,
			vue_component: vueComponent,
			d_table: dashboardTable
		},
		data() {
			return {
				dashboard: {blocks: []},
				block: {},
				mode: "small",
				names: [],
				name: "",
				user: {},
				config: {},
				initial_dashboard: null
			};
		},
		props: {
			minimal: {
				default: false
			},
			_name: {
				default: ""
			},
			// jwt d'un utilisateur simulé ("tester en tant que"), fourni par DashboardBuilder.vue
			// lors de la prévisualisation. Transmis uniquement aux blocs de lecture/affichage
			// (db, table, vue_component) - jamais aux blocs d'action (button, notifs, actions).
			test_jwt: {
				default: null
			},
			// Objet utilisateur simulé correspondant (uid/identifiant/nom/prenom/groups), fourni
			// en même temps que test_jwt par DashboardBuilder.vue. Transmis uniquement à
			// vue_component, qui l'expose comme `this.user`/`$user` à la place du vrai
			// utilisateur connecté (store.state.user) le temps de la prévisualisation.
			test_user: {
				default: null
			}
		},
		methods: {
			async refresh()
			{
				console.log("refresh");
				this.load(this.initial_dashboard);
			},
			async load_name(name)
			{
				if (name)
					this.name = name;

				console.log(this.name)

				var result = await library.getby_production("dashboard", this.name, false, true);
				this.load(result);
			},
			async load(data)
			{
				var self = this;
				if (!this.initial_dashboard)
					this.initial_dashboard = data;
				var dashboard = clone(data);
				this.mode = "small";

				if (typeof dashboard == "string")
					dashboard = JSON.parse(dashboard);

				// Sécurité : anciens dashboards ou données incomplètes
				dashboard.blocks = dashboard.blocks || [];
				dashboard.lines  = dashboard.lines  || [];

				console.log('[Dashboard] load - blocks:', dashboard.blocks.length, '| lines:', dashboard.lines.length, '| title:', dashboard.title);

				if (dashboard.lines)
				{
					var user = store.state.user || [];

					user.details.groups = user.groups;
					user.env = user.env;
					user.details.nom = user.nom;
					user.details.prenom = user.prenom;
					user.details.identifiant = user.identifiant;
		
					if (dashboard.config)
					{
						var config = dashboard.config;
						this.config = config;

						if (config.user_table)
						{
							if (config.user_table_uid_column)
							{
								var user = await database.get("select", config.user_table, {
									end: "`" + config.user_table_uid_column + "` = '" + user.uid + "'"
								});
								user = user.length > 0 ? user[0] : {}
							}
							else if (config.user_table_identifiant_column)
							{
								var user = await database.get("select", config.user_table, {
									end: "`" + config.user_table_identifiant_column + "` = '" + user.identifiant + "'"
								});
								user = user.length > 0 ? user[0] : {}
							}
						}
					}

					this.user = user.details ? clone(user.details) : clone(user);

					console.log(this.user)

					for (var i = 0; i < dashboard.lines.length; i++)
					{
						if (dashboard.lines[i].conditions && dashboard.lines[i].conditions.rules_sql)
						{
							var res = alasql(
								"SELECT * FROM ? where " + dashboard.lines[i].conditions.rules_sql,
								[[this.user]]
							);

							console.log(res)

							if (res.length == 0)
							{
								dashboard.blocks.splice(i, 1);
								dashboard.lines.splice(i, 1);
								i--;
							}
						}
					}
				}

				for (var i = 0; i < dashboard.blocks.length; i++)
				{
					for (var j = 0; j < dashboard.blocks[i].blocks.length; j++)
					{
						if (dashboard.blocks[i].blocks[j].size === 0 && j > 0)
						{
							if (!dashboard.blocks[i].blocks[j - 1].blocks)
								dashboard.blocks[i].blocks[j - 1].blocks = [];
							dashboard.blocks[i].blocks[j - 1].blocks.push(dashboard.blocks[i].blocks[j]);
							dashboard.blocks[i].blocks.splice(j, 1);
							j--;
						}
					}
				}

				this.dashboard = dashboard;

				self.$nextTick(async function () {
					for (var i = 0; i < self.dashboard.blocks.length; i++)
					{
						for (var j = 0; j < self.dashboard.blocks[i].blocks.length; j++)
						{
							try
							{
								if (self.$refs[self.dashboard.blocks[i].blocks[j].uid])
								{
									await self.$refs[self.dashboard.blocks[i].blocks[j].uid][0].load(self.dashboard.blocks[i].blocks[j].params);
								}
								
								if (self.dashboard.blocks[i].blocks[j].blocks)
								{
									for (var k = 0; k < self.dashboard.blocks[i].blocks[j].blocks.length; k++)
									{
										try 
										{
											if (self.$refs[self.dashboard.blocks[i].blocks[j].blocks[k].uid])
												await self.$refs[self.dashboard.blocks[i].blocks[j].blocks[k].uid][0].load(self.dashboard.blocks[i].blocks[j].blocks[k].params);								
										}
										catch (err) {}
									}
								}
							}
							catch (err)
							{
								console.log(err)
							}
						}
					}
				});
			},
			async setBig(id_line, idx)
			{
				var self = this;

				this.mode = "big";
				this.block = this.dashboard.blocks[id_line].blocks[idx];

				self.$nextTick(async function () {
					await self.$refs.block.load(self.block.params);
				});
			},
			async setSmall()
			{
				var self = this;
				this.mode = "small";
			},
			effectiveSize(line_blocks, block)
			{
				if (block.size > 0) return block.size;
				// size === 0 : caché (géré par v-show), on retourne null
				if (block.size === 0) return null;
				// Pas de taille définie : partager l'espace restant
				const used = line_blocks.blocks
					.filter(b => b.size > 0)
					.reduce((sum, b) => sum + b.size, 0);
				const freeCount = line_blocks.blocks
					.filter(b => !b.size && b.size !== 0).length;
				return freeCount > 0 ? Math.floor((12 - used) / freeCount) : 12;
			}
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.dashboard) {
				this.$router.push({ name: "profile" });
            }

			if (!this.minimal)
			{
				let response = await users.getSelf(true);
				var rulesName  = store.state.user.rules && store.state.user.rules.dashboard;
				var clientName = response.client && response.client.details && response.client.details.dashboard;

				// Noms forcés par config (rules ou client), séparés par |
				var forcedNames = (rulesName || clientName || "")
					.split("|").map(s => s.trim()).filter(Boolean);

				console.log('[Dashboard] mounted - rulesName:', rulesName, '| clientName:', clientName, '| forcedNames:', forcedNames);

				// Toujours charger la liste complète des dashboards actifs pour le menu
				var all = await library.getby_production("dashboard");
				var activeElements = (all && all.element || [])
					.map(el => {
						try   { var p = JSON.parse(el.data); return { ...p, _el_name: el.name }; }
						catch { return null; }
					})
					.filter(el => el && el.active)
					.sort((a, b) => (a.order || 0) - (b.order || 0));

				console.log('[Dashboard] éléments actifs:', activeElements.map(e => e._el_name));

				if (forcedNames.length > 0)
				{
					// Conserver uniquement les dashboards actifs parmi les noms forcés,
					// dans l'ordre de forcedNames
					var orderedNames = forcedNames.filter(n =>
						activeElements.some(e => e._el_name === n)
					);
					// Si les noms viennent des droits utilisateur (rulesName), on restreint strictement
					// à ces dashboards. Si seulement clientName, on complète avec les autres actifs.
					if (!rulesName) {
						activeElements.forEach(e => {
							if (!orderedNames.includes(e._el_name))
								orderedNames.push(e._el_name);
						});
					}
					this.names = orderedNames;
				}
				else
				{
					this.names = activeElements.map(e => e._el_name);
				}

				this.name = this._name && this.names.includes(this._name)
					? this._name
					: (this.names[0] || "");

				console.log('[Dashboard] names:', this.names, '| default:', this.name);

				if (this.name)
				{
					var result = await library.getby_production("dashboard", this.name, false, true);
					console.log('[Dashboard] load result:', result);
					this.load(result);
				}
			}
			else if (this._name)
			{
				this.name = this._name;
				var result = await library.getby_production("dashboard", this.name, false, true);
				console.log('[Dashboard] _name load result:', result);
				this.load(result);
			}
		},
	};
</script>

<style scoped>
h3 {
	text-align: left;
}
</style>
